var _metadata, _defs, _g, _mask, _g2, _mask2, _g3, _mask3, _g4, _mask4, _g5, _mask5, _g6, _mask6, _g7, _mask7, _g8, _mask8, _g9, _mask9, _g0, _mask0, _g1, _mask1, _g10, _mask10, _g11, _mask11, _g12, _mask12, _g13, _mask13, _g14, _mask14, _g15, _mask15, _g16, _mask16, _g17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.53749207239093 71.0342034154761",
    width: 67.53749207239093,
    height: 71.0342034154761,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    className: "style-fonts"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.16474453279011 43.654490423656114) rotate(213.0246353981788 -6.046285710795132 -0.08290893449586179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.58 -0.04, -5.16 -0.07, -12.09 -0.17 M0 0 C-2.81 -0.04, -5.61 -0.08, -12.09 -0.17",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.86700192244848 44.086374502254785) rotate(213.0246353981788 -2.575839042946768 1.993858766168529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.89 1.47, -3.79 2.93, -5.15 3.99 M0 0 C-1.4 1.08, -2.79 2.16, -5.15 3.99",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.96901112129285 48.28210645666934) rotate(213.0246353981788 2.3279211071127293 1.693364432849421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.76 1.28, 3.52 2.56, 4.66 3.39 M0 0 C0.98 0.71, 1.96 1.42, 4.66 3.39",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.13460436722221 50.63598090253009) rotate(268.0246353981789 -6.046285710795132 -0.08290893449586179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-4.64 -0.06, -9.28 -0.13, -12.09 -0.17 M0 0 C-3.11 -0.04, -6.21 -0.09, -12.09 -0.17",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.4333445270704 56.53476420980053) rotate(268.0246353981789 -2.575839042946768 1.993858766168529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.92 1.48, -3.83 2.97, -5.15 3.99 M0 0 C-1.43 1.1, -2.85 2.21, -5.15 3.99",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.616738857507016 56.88261061030079) rotate(268.0246353981789 2.3279211071127293 1.693364432849421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.83 1.33, 3.65 2.66, 4.66 3.39 M0 0 C1.76 1.28, 3.53 2.57, 4.66 3.39",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.415482800277687 43.5498544172313) rotate(326.33945076816093 -6.046285710795132 -0.08290893449586179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-4.47 -0.06, -8.95 -0.12, -12.09 -0.17 M0 0 C-3.68 -0.05, -7.35 -0.1, -12.09 -0.17",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.293689019808653 47.8054119938393) rotate(323.0246353981789 -2.575839042946768 1.993858766168529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.63 1.26, -3.26 2.52, -5.15 3.99 M0 0 C-1.09 0.85, -2.18 1.69, -5.15 3.99",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.741937805253428 43.9674964104006) rotate(323.0246353981789 2.3279211071127293 1.693364432849421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.6 1.16, 3.2 2.33, 4.66 3.39 M0 0 C1.25 0.91, 2.51 1.83, 4.66 3.39",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.38129459189281 27.287678012455444) rotate(35 -6.046285710795132 -0.08290893449586179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.59 -0.04, -5.18 -0.07, -12.09 -0.17 M0 0 C-2.58 -0.04, -5.15 -0.07, -12.09 -0.17",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask0 || (_mask0 = /*#__PURE__*/React.createElement("mask", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.829473266422156 22.422037958255032) rotate(35 -2.575839042946768 1.993858766168529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.08 0.83, -2.15 1.67, -5.15 3.99 M0 0 C-1.93 1.5, -3.86 2.99, -5.15 3.99",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask1 || (_mask1 = /*#__PURE__*/React.createElement("mask", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.052432426522728 18.932819944676112) rotate(35 2.3279211071127293 1.693364432849421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.74 1.27, 3.48 2.53, 4.66 3.39 M0 0 C1.6 1.16, 3.2 2.33, 4.66 3.39",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.644936217365284 20.72501271611418) rotate(90 -6.046285710795132 -0.08290893449586179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.45 -0.03, -4.91 -0.07, -12.09 -0.17 M0 0 C-3.51 -0.05, -7.02 -0.1, -12.09 -0.17",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.68186387915716 10.581980276778097) rotate(90 -2.575839042946768 1.993858766168529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2 1.55, -4.01 3.1, -5.15 3.99 M0 0 C-1.42 1.1, -2.84 2.2, -5.15 3.99",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.68966195831081 11.004495419018212) rotate(90 2.3279211071127293 1.693364432849421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.5 1.09, 3 2.18, 4.66 3.39 M0 0 C1.26 0.92, 2.53 1.84, 4.66 3.39",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.11224205556823 28.2453536084584) rotate(148.31481536998209 -6.046285710795132 -0.08290893449586179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-4.71 -0.06, -9.41 -0.13, -12.09 -0.17 M0 0 C-4.53 -0.06, -9.06 -0.12, -12.09 -0.17",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.5080580337069 20.03482440502853) rotate(145 -2.575839042946768 1.993858766168529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.91 1.48, -3.82 2.96, -5.15 3.99 M0 0 C-1.79 1.38, -3.58 2.77, -5.15 3.99",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.10806524714371 24.56254505193192) rotate(145 2.3279211071127293 1.693364432849421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.64 1.19, 3.28 2.39, 4.66 3.39 M0 0 C1.2 0.87, 2.4 1.74, 4.66 3.39",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask16 || (_mask16 = /*#__PURE__*/React.createElement("mask", null)), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(26.198755017962412 27.61536220952155) rotate(38.47737597215341 7.651159299639517 7.699892369221516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3 7.7 C15.3 8.15, 15.26 8.6, 15.19 9.04 C15.11 9.48, 14.99 9.91, 14.84 10.33 C14.69 10.75, 14.5 11.16, 14.28 11.55 C14.06 11.94, 13.8 12.31, 13.51 12.65 C13.23 12.99, 12.91 13.31, 12.57 13.6 C12.23 13.88, 11.86 14.15, 11.48 14.37 C11.09 14.59, 10.68 14.78, 10.27 14.94 C9.85 15.09, 9.42 15.21, 8.98 15.28 C8.54 15.36, 8.09 15.4, 7.65 15.4 C7.21 15.4, 6.76 15.36, 6.32 15.28 C5.89 15.21, 5.45 15.09, 5.03 14.94 C4.62 14.78, 4.21 14.59, 3.83 14.37 C3.44 14.15, 3.07 13.88, 2.73 13.6 C2.39 13.31, 2.07 12.99, 1.79 12.65 C1.51 12.31, 1.25 11.94, 1.03 11.55 C0.8 11.16, 0.61 10.75, 0.46 10.33 C0.31 9.91, 0.19 9.48, 0.12 9.04 C0.04 8.6, 0 8.15, 0 7.7 C0 7.25, 0.04 6.8, 0.12 6.36 C0.19 5.92, 0.31 5.49, 0.46 5.07 C0.61 4.65, 0.8 4.24, 1.03 3.85 C1.25 3.46, 1.51 3.09, 1.79 2.75 C2.07 2.41, 2.39 2.09, 2.73 1.8 C3.07 1.51, 3.44 1.25, 3.83 1.03 C4.21 0.81, 4.62 0.62, 5.03 0.46 C5.45 0.31, 5.89 0.19, 6.32 0.12 C6.76 0.04, 7.21 0, 7.65 0 C8.09 0, 8.54 0.04, 8.98 0.12 C9.42 0.19, 9.85 0.31, 10.27 0.46 C10.68 0.62, 11.09 0.81, 11.48 1.03 C11.86 1.25, 12.23 1.51, 12.57 1.8 C12.91 2.09, 13.23 2.41, 13.51 2.75 C13.8 3.09, 14.06 3.46, 14.28 3.85 C14.5 4.24, 14.69 4.65, 14.84 5.07 C14.99 5.49, 15.11 5.92, 15.19 6.36 C15.26 6.8, 15.28 7.48, 15.3 7.7 C15.32 7.92, 15.32 7.48, 15.3 7.7",
    stroke: "#005e79",
    strokeWidth: 4,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinter);
export default __webpack_public_path__ + "static/media/winter.d0e97810a42fdba47280eeb79cd908e1.svg";
export { ForwardRef as ReactComponent };